import React from 'react'

import styled from 'styled-components'

import { ProfileSocialSharing } from 'components/block/sharingButton/ProfileSocialSharing'
import { media } from 'components/presentational'

export const SharingFlex = styled.div`
  display: flex;
  justify-content: center;

  ${media.tabletLarge`
    margin-top: 10px;
  `}
`

export const Sharing = () => {
  return (
    <SharingFlex>
      <ProfileSocialSharing />
    </SharingFlex>
  )
}
